var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question-select"},[(!!_vm.question)?_c('div',{staticClass:"question"},[_vm._v(" "+_vm._s(_vm.question)+" ")]):_vm._e(),_c('div',{staticClass:"textarea-wrapper"},[_c('ChatSelect',{attrs:{"value":_vm.value,"columns":_vm.columns},on:{"input":_vm.onInput}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }